export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'loading': 'Loading',
            'APPLICATIONS': 'Applications',
            'SAMPLE'        : {
                'TITLE': 'Sample',
                'BADGE': '25'
            }
        }
    }
};
